import "./DropdownOverlay.scss"
import { MouseEventHandler } from "react"

export interface DropdownItem {
    text: string
    icon?: React.ReactNode
    onClick?: MouseEventHandler<HTMLDivElement>
}

export interface DropdownOverlayProps {
    items: DropdownItem[]
    onClick?: () => void
}

export default function DropdownOverlay(props: DropdownOverlayProps) {
    return (
        <div className="dropdown-menu-overlay" onClick={props.onClick}>
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                {props.items.map((item, index) => (
                    <div
                        key={index}
                        className='menu-item'
                        onClick={item.onClick}>
                            <span className="font-lato">{item.text}</span>
                            {item.icon}
                    </div>
                ))}
            </div>
        </div>
    )
}
